// core/items/ItemsCommand.ts
/**
 * Команды для управления элементами.
 */
var ItemsCommand;
(function (ItemsCommand) {
    // ── Выбор ────────────────────────────────
    /** Выделить один или несколько элементов */
    ItemsCommand["select"] = "select";
    /** Выделить все элементы */
    ItemsCommand["selectAll"] = "selectAll";
    /** Снять выделение с одного или нескольких элементов */
    ItemsCommand["unselect"] = "unselect";
    /** Снять выделение со всех элементов */
    ItemsCommand["unselectAll"] = "unselectAll";
    /** Удалить выбранные элементы */
    ItemsCommand["deleteSelected"] = "deleteSelected";
    /** Обратить выделение элементов */
    ItemsCommand["toggle"] = "toggle";
    // ── CRUD ─────────────────────────────────
    /** Добавить новый элемент */
    ItemsCommand["insert"] = "insert";
    /** Обновить существующий элемент */
    ItemsCommand["update"] = "update";
    /** Удалить элемент(ы) по id */
    ItemsCommand["delete"] = "delete";
    /** Изменить пометку удаления */
    ItemsCommand["delMark"] = "delMark";
    /** Перезагрузить данные одного элемента */
    ItemsCommand["reloadItem"] = "reloadItem";
    /** Перезагрузить все элементы */
    ItemsCommand["reloadAll"] = "reloadAll";
    // ── Папки / группы ──────────────────────
    /** Создать новую папку или группу */
    ItemsCommand["createFolder"] = "createFolder";
    /** Переименовать папку или группу */
    ItemsCommand["renameFolder"] = "renameFolder";
    /** Удалить папку или группу */
    ItemsCommand["deleteFolder"] = "deleteFolder";
    /** Переместить элементы в указанную папку */
    ItemsCommand["moveItemsToFolder"] = "moveItemsToFolder";
    // ── Порядок элементов ───────────────────
    /** Поднять выбранные элементы на шаг вверх */
    ItemsCommand["moveUp"] = "moveUp";
    /** Опустить выбранные элементы на шаг вниз */
    ItemsCommand["moveDown"] = "moveDown";
    /** Установить явный порядок элементов */
    ItemsCommand["setOrder"] = "setOrder";
})(ItemsCommand || (ItemsCommand = {}));

export { ItemsCommand };
